/** Ids only. Titles, hints and riddles live in slots.ts and hunt/pumpkin-spots.ts (lazy chunks only). */
export const SLOT_IDS = [
  'spooky-mode',
  'boo',
  'pumpkin-loader',
  'logo-13',
  'cursed-numbers',
  'witching-hour',
  'pumpkin-hunt',
  'graveyard',
] as const

export type SlotId = (typeof SLOT_IDS)[number]

export const PUMPKIN_IDS = ['p1', 'p2', 'p3', 'p4', 'p5'] as const

export type PumpkinId = (typeof PUMPKIN_IDS)[number]
